var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-white pb-16"},[(_vm.accOrder)?_c('Preview',{attrs:{"acc-order":_vm.accOrder}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }